(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["at-password-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const frame = document.querySelector('[data-atv3-frame]');
    const art = document.querySelector('[data-atv3-art]');
    const cap = document.querySelector('[data-atv3-cap]');
    const dialog = document.querySelector('[data-atv3-dialog]');
    document.querySelector('[data-atv3-open]')?.addEventListener('click', () => dialog?.showModal());
    document.querySelector('[data-atv3-close]')?.addEventListener('click', () => dialog?.close());
    if (dialog?.querySelector('[data-atv3-pw-error]')) dialog.showModal();
    if (!frame || !art) return;

    const imgs = [...art.querySelectorAll('.atv3__img')];
    if (!imgs.length) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let k = 0, zoomed = false, timers = [];
    const at = (ms, fn) => timers.push(setTimeout(fn, ms));
    const clear = () => { timers.forEach(clearTimeout); timers = []; };

    // Aus 3 m das schöne Bild, aus 30 cm die Pointe: die Kamera fährt auf den Fokuspunkt
    function focusTransform(i) {
      const im = imgs[i], fx = +im.dataset.fx || 50, fy = +im.dataset.fy || 50, s = +im.dataset.zoom || 2;
      const fw = frame.offsetWidth, fh = frame.offsetHeight;
      const a = art.getBoundingClientRect(), f = frame.getBoundingClientRect(), sc = f.width / fw;
      const ax = (a.left - f.left) / sc, ay = (a.top - f.top) / sc, aw = a.width / sc, ah = a.height / sc;
      const dx = ax + aw * fx / 100 - fw / 2, dy = ay + ah * fy / 100 - fh / 2;
      return `translate(${-dx * s}px, ${-dy * s}px) scale(${s})`;
    }
    const zoomIn = () => { if (reduce) return; frame.style.transform = focusTransform(k); frame.classList.add('is-zoomed'); zoomed = true; };
    const zoomOut = () => { frame.style.transform = 'translate(0, 0) scale(1)'; frame.classList.remove('is-zoomed'); zoomed = false; };
    const showCap = t => { cap.classList.add('is-out'); setTimeout(() => { cap.textContent = t || ''; cap.classList.remove('is-out'); }, 350); };
    const hideCap = () => cap.classList.add('is-out');

    function show(i) {
      imgs.forEach((im, j) => im.classList.toggle('is-on', j === i));
      const next = imgs[(i + 1) % imgs.length]; if (next.loading === 'lazy') next.loading = 'eager';
      clear();
      if (reduce) { showCap(imgs[i].dataset.caption); at(6000, () => go(i + 1)); return; }
      hideCap();
      at(1400, zoomIn);
      at(4000, () => showCap(imgs[i].dataset.caption));
      at(8200, zoomOut);
      at(10600, () => go(i + 1));
    }
    function go(i) { k = (i + imgs.length) % imgs.length; show(k); }
    function toggle() {
      clear();
      if (zoomed) { zoomOut(); at(2600, () => go(k + 1)); }
      else { zoomIn(); showCap(imgs[k].dataset.caption); at(6000, () => { zoomOut(); at(2400, () => go(k + 1)); }); }
    }
    frame.addEventListener('click', toggle);
    frame.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    addEventListener('resize', () => { if (zoomed) frame.style.transform = focusTransform(k); });
    go(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["at-password-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.atv4');
    if (!root) return;
    const $ = s => root.querySelector(s);
    const dialog = $('[data-atv4-dialog]');
    $('[data-atv4-open]')?.addEventListener('click', () => dialog?.showModal());
    $('[data-atv4-close]')?.addEventListener('click', () => dialog?.close());
    if (dialog?.querySelector('[data-atv4-pw-error]')) dialog.showModal();

    // Teilen nach der Anmeldung
    const share = $('[data-atv4-share]');
    if (share) {
      const url = share.dataset.url, text = share.dataset.text;
      const copy = share.querySelector('[data-atv4-copy]');
      const copyLink = () => navigator.clipboard?.writeText(url).then(() => { copy.textContent = copy.dataset.done; });
      copy?.addEventListener('click', copyLink);
      share.querySelector('[data-atv4-native]')?.addEventListener('click', () => {
        if (navigator.share) navigator.share({ title: document.title, text, url }).catch(() => {});
        else copyLink();
      });
    }

    // Handy: Leiste unten, solange das E-Mail-Feld nicht im Bild ist
    const dock = $('[data-atv4-dock]'), field = $('[data-atv4-field]');
    if (dock && field && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const on = en.intersectionRatio < .9;
        dock.classList.toggle('is-on', on); dock.tabIndex = on ? 0 : -1; dock.setAttribute('aria-hidden', String(!on));
      }, { threshold: [0, .5, .9, 1] }).observe(field);
      dock.addEventListener('click', () => { field.scrollIntoView({ behavior: 'smooth', block: 'center' }); field.querySelector('input')?.focus({ preventScroll: true }); });
    }

    // Aus 3 m das schöne Bild, aus 30 cm die Pointe: die Kamera fährt auf den Fokuspunkt
    const stage = $('[data-atv4-stage]'), frame = $('[data-atv4-frame]'), art = $('[data-atv4-art]');
    const cap = $('[data-atv4-cap]'), count = $('[data-atv4-count]');
    if (!frame || !art) return;
    const imgs = [...art.querySelectorAll('.atv4__img')];
    if (!imgs.length) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pad = n => String(n).padStart(2, '0');
    let k = 0, zoomed = false, timers = [];
    const at = (ms, fn) => timers.push(setTimeout(fn, ms));
    const clear = () => { timers.forEach(clearTimeout); timers = []; };
    function focusTransform(i) {
      const im = imgs[i], fx = +im.dataset.fx || 50, fy = +im.dataset.fy || 50, s = +im.dataset.zoom || 2;
      const fw = frame.offsetWidth, fh = frame.offsetHeight;
      const a = art.getBoundingClientRect(), f = frame.getBoundingClientRect(), sc = f.width / fw;
      const ax = (a.left - f.left) / sc, ay = (a.top - f.top) / sc, aw = a.width / sc, ah = a.height / sc;
      const dx = ax + aw * fx / 100 - fw / 2, dy = ay + ah * fy / 100 - fh / 2;
      return `translate(${-dx * s}px, ${-dy * s}px) scale(${s})`;
    }
    const zoomIn = () => { if (reduce) return; frame.style.transform = focusTransform(k); frame.classList.add('is-zoomed'); stage.classList.add('is-zooming'); zoomed = true; };
    const zoomOut = () => { frame.style.transform = 'translate(0, 0) scale(1)'; frame.classList.remove('is-zoomed'); stage.classList.remove('is-zooming'); zoomed = false; };
    const showCap = t => { cap.classList.add('is-out'); setTimeout(() => { cap.textContent = t || ''; cap.classList.remove('is-out'); }, 350); };

    function show(i) {
      imgs.forEach((im, j) => im.classList.toggle('is-on', j === i));
      const next = imgs[(i + 1) % imgs.length]; if (next.loading === 'lazy') next.loading = 'eager';
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(imgs.length);
      clear(); zoomOut();
      if (reduce) { showCap(imgs[i].dataset.caption); at(6000, () => go(i + 1)); return; }
      cap.classList.add('is-out');
      at(1400, zoomIn);
      at(4000, () => showCap(imgs[i].dataset.caption));
      at(8200, zoomOut);
      at(10600, () => go(i + 1));
    }
    function go(i) { k = (i + imgs.length) % imgs.length; show(k); }
    function toggle() {
      clear();
      if (zoomed) { zoomOut(); at(2600, () => go(k + 1)); }
      else { zoomIn(); showCap(imgs[k].dataset.caption); at(6000, () => { zoomOut(); at(2400, () => go(k + 1)); }); }
    }
    frame.addEventListener('click', toggle);
    frame.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    $('[data-atv4-next]')?.addEventListener('click', () => go(k + 1));
    let sx = null;
    stage.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', e => { if (sx === null) return; const d = e.changedTouches[0].clientX - sx; if (Math.abs(d) > 50) go(k + (d < 0 ? 1 : -1)); sx = null; });
    addEventListener('resize', () => { if (zoomed) frame.style.transform = focusTransform(k); });
    go(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
